import React, { useState, useEffect } from "react";
import Select from "components/shared/Select";
import { components } from "react-select";
import helpers from "helpers/base";

const selectInputTextPrefix = "Sort by: ";

const sortOptionLabels = {
  author: "Author A-Z",
  recent: "Recently Added",
  title: "Title A-Z"
};
function GuideListSortControl(props) {
  const [sortOption, setSortOption] = useState(props.defaultSortOption);

  // changes to query params will be passed downstream to this component
  useEffect(() => {
    if (
      props.queryParamOptions &&
      props.queryParamOptions.sortOption !== sortOption
    ) {
      const sortOptionFromQP =
        props.queryParamOptions.sortOption || props.sortOptions.title;
      setSortOption(sortOptionFromQP);
      props.onSetSortOption(sortOptionFromQP, false);
    }
  }, [props.queryParamOptions]);

  const selectSortOptions = helpers.object.map(
    sortOptionLabels,
    (key, value) => {
      return { label: value, value: key };
    }
  );
  const sortOptionIsTitle = sortOption === props.sortOptions.title;
  const sortOptionIsAuthor = sortOption === props.sortOptions.author;
  const sortOptionIsRecent = sortOption === props.sortOptions.recent;

  const handleChange = (option) => {
    setSortOption(option.value);
    props.onSetSortOption(option.value);
  };

  const handleClickSortOptionTitle = () => {
    setSortOption(props.sortOptions.title);
    props.onSetSortOption(props.sortOptions.title);
  };

  const handleClickSortOptionAuthor = () => {
    setSortOption(props.sortOptions.author);
    props.onSetSortOption(props.sortOptions.author);
  };

  const handleClickSortOptionRecent = () => {
    setSortOption(props.sortOptions.recent);
    props.onSetSortOption(props.sortOptions.recent);
  };

  return (
    <div className="guide-list__control guide-list__control--sort">
      <div className="md:tw-hidden" style={{ width: "100%" }}>
        <Select
          options={selectSortOptions}
          baseClassName="lc-select-container--md"
          containerClassName="select-container guide-list__control-select--xxs"
          value={sortOption}
          isControlled
          name="guide-list__sort-select"
          onChange={(option) => handleChange(option)}
          labelText="Sort"
        />
        <Select
          options={selectSortOptions}
          baseClassName="lc-select-container--md"
          containerClassName="select-container guide-list__control-select--xs"
          value={sortOption}
          isControlled
          name="guide-list__sort-select"
          onChange={(option) => handleChange(option)}
          components={{
            /* eslint-disable react/no-unstable-nested-components */
            IndicatorSeparator: () => null,
            Placeholder: ({ children, ...selectProps }) => {
              return (
                <components.Placeholder {...selectProps}>
                  {selectInputTextPrefix + children}
                </components.Placeholder>
              );
            },
            SingleValue: ({ children, ...selectProps }) => {
              return (
                <components.SingleValue {...selectProps}>
                  {selectInputTextPrefix + children}
                </components.SingleValue>
              );
            }
            /* eslint-enable react/no-unstable-nested-components */
          }}
        />
      </div>
      <div className="tw-hidden md:tw-block">
        <span>Sort:</span>
        <button
          className={`btn guide-list__sort-option ${
            sortOptionIsTitle ? "guide-list__sort-option--active" : ""
          }`}
          data-testid="GuideList-SortTitle"
          onClick={handleClickSortOptionTitle}
          type="button"
        >
          {sortOptionLabels.title}
        </button>
        <button
          className={`btn guide-list__sort-option ${
            sortOptionIsAuthor ? "guide-list__sort-option--active" : ""
          }`}
          data-testid="GuideList-SortAuthor"
          onClick={handleClickSortOptionAuthor}
          type="button"
        >
          {sortOptionLabels.author}
        </button>
        <button
          className={`btn guide-list__sort-option ${
            sortOptionIsRecent ? "guide-list__sort-option--active" : ""
          }`}
          data-testid="GuideList-SortRecent"
          onClick={handleClickSortOptionRecent}
          type="button"
        >
          {sortOptionLabels.recent}
        </button>
      </div>
    </div>
  );
}

export default GuideListSortControl;
